import { useCallback } from 'react';
import { Checkbox } from 'src/client/components/recruitments/Checkbox';
import { useRecruitmentListContext } from 'client/contexts/recruitments/RecruitmentList';

export const OnlyRecruitingCheckbox = () => {
  const {
    searchQueryParams: { onlyRecruiting },
    dispatch,
  } = useRecruitmentListContext();

  const handleClickCheckbox = useCallback(() => {
    dispatch({
      type: 'changeOnlyRecruiting',
      payload: { onlyRecruiting: !onlyRecruiting },
    });
  }, [onlyRecruiting]);

  return (
    <div
      className="w-full inline-flex items-center justify-between pt-5 pb-4 border-b border-light-gray"
      onClick={() => handleClickCheckbox()}
      data-testid={`recruitment-state-checkbox`}
    >
      <Checkbox label={'募集中の求人のみ表示する'} checked={!!onlyRecruiting} onClick={() => {}} />
      <div className="divider"></div>
    </div>
  );
};
